










































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ProjectsList",
  components: {},
})
export default class HomeView extends Vue {}
